export const API_URL = process.env.REACT_APP_API_URL || '/api/'
export const CONSTRUCTOR_LINK = process.env.REACT_APP_CONSTRUCTOR_LINK || 'https://constructor.testu.online'
export const VK_API_URL = "https://vk.com/js/api/openapi.js?169";
export const VK_APP_ID = process.env.REACT_APP_VK_APP_ID;
export const VK_AUTH_CODE_KEY = process.env.REACT_APP_VK_AUTH_CODE_KEY;
